import { defineFeature } from "../core/composition/define-feature.js";
import { collectErrors } from "../behaviors/collect-errors.js";
//#region src/playback/features/error.ts
/** The behaviors the feature composes, in setup order. */
const behaviors = [collectErrors];
/** The config defaults the feature contributes. */
const defaultConfig = {};
/** The state values the feature seeds. */
const initialState = {};
/** Collects the errors the other features report into `state.errors`, per source. Without it, reporting is a no-op. */
const errorFeature = defineFeature({
	behaviors,
	defaultConfig,
	initialState
});
//#endregion
export { behaviors, defaultConfig, errorFeature, initialState };

//# sourceMappingURL=error.js.map